<script>
	import { createEventDispatcher } from 'svelte';

	export let moduleInfo = null;
	export let selectedDetail = null;

	const dispatch = createEventDispatcher();

	function close() {
		dispatch('close');
	}
</script>

<aside class="panel">
	<button class="back-btn" on:click={close}>{moduleInfo ? '← Retour' : '✕ Fermer'}</button>
	{#if moduleInfo}
		<h2>{moduleInfo.name}</h2>
		<p class="description">{moduleInfo.description}</p>
	{/if}
	{#if selectedDetail}
		{#if moduleInfo}<hr />{/if}
		<h3>{selectedDetail.label}</h3>
		<p class="description">{selectedDetail.description}</p>
	{/if}
</aside>

<style>
	.panel {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		width: 320px;
		background: rgba(12, 10, 21, 0.92);
		border-left: 1px solid rgba(0, 229, 255, 0.15);
		padding: 24px 20px;
		color: #dde8f0;
		overflow-y: auto;
		z-index: 100;
	}

	.back-btn {
		background: none;
		border: 1px solid rgba(0, 229, 255, 0.3);
		color: var(--cyan);
		padding: 6px 12px;
		border-radius: 6px;
		cursor: pointer;
		margin-bottom: 20px;
		font-size: 13px;
	}
	.back-btn:hover {
		background: rgba(0, 229, 255, 0.1);
	}

	h2 {
		color: var(--cyan);
		text-shadow: 0 0 10px rgba(0, 229, 255, 0.3);
		margin: 0 0 12px;
	}
	h3 {
		color: var(--amber);
		margin: 0 0 8px;
	}
	.description {
		font-size: 14px;
		line-height: 1.5;
		color: rgba(221, 232, 240, 0.85);
	}
	hr {
		border: none;
		border-top: 1px solid rgba(0, 229, 255, 0.15);
		margin: 20px 0;
	}

	/* Keep in sync with MOBILE_MQ / PANEL_H_RATIO in App.svelte (centerOn). */
	@media (max-width: 768px) {
		.panel {
			top: auto;
			left: 0;
			width: auto;
			max-height: 45dvh;
			border-left: none;
			border-top: 1px solid rgba(0, 229, 255, 0.25);
			border-radius: 14px 14px 0 0;
			padding: 16px 16px calc(16px + env(safe-area-inset-bottom, 0px));
		}
		.back-btn {
			margin-bottom: 12px;
		}
		h2 {
			font-size: 20px;
			margin-bottom: 8px;
		}
		hr {
			margin: 12px 0;
		}
	}
</style>
